// Bruitage des vagues de la première page.
// Toute la mécanique vit dans openingSound.js : UN SEUL lecteur audio joue le
// gong avec la mer, puis enchaîne sur la boucle de mer (méthode fiable iPhone —
// un deuxième lecteur dans le même geste était bloqué par iOS).
// Ce module ne fait que déléguer, pour ne pas toucher aux pages qui l'importent.
import { armOpeningSound, fadeOpeningSound } from "@/lib/openingSound";

export function startWaves() {
    armOpeningSound();
}

export function stopWaves() {
    fadeOpeningSound();
}
